import openSocket from "socket.io-client";
import appConfig from "../helpers/appConfig";
//export const socket = openSocket.connect();
export const socket = openSocket.connect(`${appConfig.endpoint}`, {
  reconnect: true,
});
